import { z } from 'zod';
import { Module } from './roles.js';

export const WorkspaceSummary = z.object({
  workspace_id: z.string(),
  client_conf_key: z.string(),
  name: z.string().nullable().optional(),
  domain: z.string().nullable().optional(),
  modules: z.array(Module),
  is_suspended: z.boolean(),
  is_active: z.boolean(),
  environment: z.string().nullable().optional(),
  reseller_id: z.string().nullable().optional(),
});
export type WorkspaceSummary = z.infer<typeof WorkspaceSummary>;

export const ModuleConfig = z.object({
  backend: z
    .object({
      domain: z.string().optional(),
      endpoint: z.string().optional(),
    })
    .partial()
    .optional(),
  ttl: z.union([z.number(), z.string(), z.record(z.string(), z.number())]).optional(),
  CloudFrontDetails: z.record(z.string(), z.unknown()).optional(),
  sitemapUrl: z.string().optional(),
  allow404: z.boolean().optional(),
});
export type ModuleConfig = z.infer<typeof ModuleConfig>;

export const WorkspaceDetail = WorkspaceSummary.extend({
  poc_email: z.string().email().nullable().optional(),
  poc_name: z.string().nullable().optional(),
  poc_mobile: z.string().nullable().optional(),
  poc_tg_username: z.string().nullable().optional(),
  billing_address: z.record(z.string(), z.unknown()).nullable().optional(),
  allowedIPs: z.array(z.string()).nullable().optional(),
  modulesOnboarded: z.array(Module),
  optimizationFlag: z.boolean().nullable().optional(),
  fetchLiveLogs: z.boolean().nullable().optional(),
  improvize: z.union([z.number(), z.string()]).nullable().optional(),
  branding: z.record(z.string(), z.unknown()).nullable().optional(),
  mcp_conf: z.record(z.string(), z.unknown()).nullable().optional(),
  backend: z.record(z.string(), z.unknown()).nullable().optional(),
  ttl: z.union([z.number(), z.string(), z.record(z.string(), z.number())]).nullable().optional(),
  CloudFrontDetails: z.record(z.string(), z.unknown()).nullable().optional(),
  sitemapUrl: z.string().nullable().optional(),
  allow404: z.boolean().nullable().optional(),
  secrets_present: z.object({
    secret: z.boolean(),
    access_key: z.boolean(),
  }),
  last_rotation: z.object({
    secret: z.string().nullable().optional(),
    access_key: z.string().nullable().optional(),
  }),
  onBoardedOn: z.union([z.string(), z.number()]).nullable().optional(),
  created_on: z.union([z.string(), z.number()]).nullable().optional(),
  updated_on: z.union([z.string(), z.number()]).nullable().optional(),
});
export type WorkspaceDetail = z.infer<typeof WorkspaceDetail>;

export const WorkspacesListResponse = z.object({
  workspaces: z.array(WorkspaceSummary),
  total: z.number().int().nonnegative(),
  page: z.number().int().nonnegative(),
  page_size: z.number().int().positive(),
});
export type WorkspacesListResponse = z.infer<typeof WorkspacesListResponse>;
